export default "__VITE_ASSET__DOgOQpuh__"